/* eslint-disable sort-keys */
import { AccommodationsService } from 'sat-core';

AccommodationsService.ACCOMMODATIONS_CONFIG = () => {
  return {
    assessmentSection: {
      show: true, // overrides all other assessment options if false
      toggles: {
        // toggles marked as true will appear in the order shown here
        scientificCalculatorToggle: true,
        basicCalculatorToggle: false,
        textToSpeechToggle: false,
        translationToggle: false,
        dictionaryToggle: false,
        contentLanguageToggle: false,
        graphingCalculatorToggle: false,
        spellcheckerToggle: false
      }
    },
    lessonSection: {
      show: true, // overrides all other lesson options if false
      toggles: {
        // toggles marked as true will appear in the order shown here
        scientificCalculatorToggle: true,
        basicCalculatorToggle: false,
        textToSpeechToggle: false,
        translationToggle: false,
        dictionaryToggle: false,
        graphingCalculatorToggle: false,
        spellcheckerToggle: false
      }
    },
    cellDividerClassName: 'section-divider',
    showTopHeader: true,
    tableHeaderFontSize: 'inherit',
    treatAllSectionsAsOne: false
  };
};
